/* eslint-disable max-statements */
import $ from 'jquery';
import _ from 'lodash';
import {assoc} from 'ramda';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import React from 'react';
import {render as reactRender} from 'react-dom';
import eventChannels from '@sinclair-digital/stl-common/src/eventChannels';
import {fetchJsonV1} from '@sinclair-digital/v2-content-service/lib/fetch';
import countErrorMessage from '@sinclair-digital/stl-common/src/util/countErrorMessage';
import TaggingRightPanelView from '@sinclair-digital/stl-common/src/views/common/_taggingRightPanelView';
import {logError} from '@sinclair-digital/stl-common/src/analytics/common';
import {changeVideoAttribute, mp4Download, saveVideoChanges} from '@sinclair-digital/stl-common/src/analytics/mediaPackage';
import videoFlyoverTemplate from '../../templates/media/videoFlyover.hbs';
import {beforeMainLoader, completeMainLoader} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import {messageHandler} from '@sinclair-digital/stl-common/src/sinclair/sinclair.uiTools';
import {search} from '@sinclair-digital/stl-common/src/sinclair/sinclair.media.utils';
import clipping from '../../clipper/clipping';
import clipperUiView from './clipperUiView'; // new clipper ui
import VideoModel from '@sinclair-digital/stl-common/src/models/media/videoModel';
import VideoCollection from '@sinclair-digital/stl-common/src/collections/media/videoCollection';
import {maxLength} from '@sinclair-digital/stl-common/src/util/validators';
import {richTextRegex} from '@sinclair-digital/stl-common/src/util/text';
import {DEFAULT_MEDIA_CAPTION_MAXLENGTH} from '@sinclair-digital/stl-common/src/models/media/mediaModel';
import {destroy, bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';
import {MediaAccessRightsSidebarItem} from '@sinclair-digital/sbg-storyline-components/src/components/MediaAccessRights';
import {getAvailableBrandUuids, getAvailableAdminBrandUuids} from '@sinclair-digital/stl-common/src/models/Brand';
import {getFeatureFlag} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/featureFlags';
import {MediaTagsSidebarItem} from './MediaTags/MediaTagsSidebarItem';
import {parse, stringify} from '@sinclair-digital/stl-common/src/sinclair/sinclair.markdown';

const VideoEditorView = Backbone.View.extend({
    events: {
        transitionend: '_initEditors',
        'click #video-editor-panel-open': '_openClippingPanel',
        'change #modal-name': '_gaLogChangeTitle',
        'change #media-video-caption': '_gaLogChangeCaption',
        'change #modal-alt': '_gaLogChangeAltText',
        'click .sda-btn-video-download': '_gaDownloadVideo',
        'click .sda-select-thumbnail-btn': '_selectThumbnail',
    },
    initialize(opts = {}) {
        bindAllMethods(this);
        this._registerHandlebarHelpers();

        this.inStory = opts.inStory;

        this.listenTo(eventChannels.media.library, 'clip.broadcast', this.render);
        this.listenTo(
            eventChannels.targeting,
            'change.target',
            target => (this.siteId = target ? target.get('site').get('uuid') : this.siteId),
        );

        $(document)
            .off('keydown')
            .off('keyup')
            .on('keydown', function (e) {
                clipping.videoKeydown(e);
            })
            .on('keyup', function (e) {
                clipping.videoKeyup(e);
            });
    },
    render(model) {
        // This view is weird because we are using the sinclair clipping module.
        // TODO: Import code from the clipping module into this view or the videoClippingView
        // (depending on how much work is done in the clipping module itself.

        /*
         * FIX for NLP-1055: VDMS support has stated that there is no way to configure their API to return https
         * instead of http.  They did agree that we should be able to just use https interchangeably for this URL.
         * "After speaking with our engineering team we do not currently have a way change the url provided by the
         * API to https. But changing it to https for your workflow should cause no issues." Dan Rossin @ VDMS Support
         */
        // NOTE: mp4Url does not exist on legacyModel objects passed into this method, so we need to not break those.
        if (model.attributes?.mp4Url?.match?.call(/uplynk\.com/)) {
            model.attributes = {...model.attributes, mp4Url: model.attributes.mp4Url.replace('http://', 'https://')};
        }

        this.newModel = model;

        if (model.isNewscast) {
            this.openVideoClippingView(model);
        } else {
            model
                .getLegacyLiveAssetModel()
                .then(assoc('isNewscast', false))
                .then(this.openVideoClippingView);
        }
    },
    _initEditors() {
        const $editors = this.$('.sda-editor');
        if ($editors.length && !$editors.data('sdaEditor')) {
            $editors.sdaEditor().data('sdaEditor');
        }
    },
    /**
     * Is triggered when clicking on the 'capture as thumbnail' button.
     * This is only used by /media route, not any others
     *
     * @private
     */
    _selectThumbnail() {
        this.$('.sda-select-thumbnail-btn').attr('disabled', 'disabled');
        const videoUuid = this.newModel.get('uuid');
        const framePoint = this.$('.sda-media-editor').getVidsvcs().player.getCurrentTime();

        if (framePoint !== 0) {
            beforeMainLoader();
            const url = `/api/rest/media/get-video-thumbnail-at-position?videoUuid=${videoUuid}&framePoint=${framePoint}`;
            fetchJsonV1(url)
                .then(asset => {
                    if (this.inStory) {
                        eventChannels.media.library.trigger('attach.media', [asset.uuid]);

                        // update model w/ new thumbnail url
                        this.newModel.set({thumbUrl: asset.originalUrl});

                        // visually update thumbnail image on page w/ captured thumbnail without re-rendering
                        document.getElementsByClassName('sda-select-thumbnail-img')[0].src = asset.originalUrl;

                        this._attributeChanged('thumbUrl');
                    } else {
                        messageHandler('success', 'Frame saved to media library.');
                    }
                })
                .catch(() => messageHandler('error', 'There was an error saving the frame.'))
                .finally(() => {
                    this.$('.sda-select-thumbnail-btn').removeAttr('disabled');
                    completeMainLoader();
                });
        } else {
            messageHandler('error', 'Video not playing or start point at beginning of video.');
            this.$('.sda-select-thumbnail-btn').removeAttr('disabled');
        }
    },
    destroy() {
        $(document).off('keydown');
        $(document).off('keyup');
    },
    openVideoClippingView(legacyModel) {
        const that = this;
        const uuid = legacyModel.get('video').uuid;

        if (that.tagging) {
            destroy(that.tagging);
        }

        legacyModel.set('siteid', that.siteId);

        $('body').addClass('hide-nav');
        $('.sda-nav-panel').removeClass('panel-open');
        const parser = new DOMParser();
        const title = legacyModel?.attributes?.video?.title ? parser.parseFromString(parse(legacyModel.attributes.video.title), 'text/html') : '';
        const cleanTitle = (title?.body?.textContent || '').replace(/\u00A0/g, ' ');
        const alt = legacyModel?.attributes?.video?.alt ? parser.parseFromString(parse(legacyModel.attributes.video.alt), 'text/html') : '';
        const cleanAlt = (alt?.body?.textContent || '').replace(/\u00A0/g, ' ');
        const viewModel = Object.assign({}, legacyModel, {
            attributes: {
                ...legacyModel.attributes,
                video: {
                    ...legacyModel.attributes.video,
                    caption: legacyModel?.attributes?.video?.caption && parse(legacyModel.attributes.video?.caption || ''),
                    title: legacyModel?.attributes?.video?.title && cleanTitle,
                    alt: legacyModel?.attributes?.video?.alt && cleanAlt,
                },
            },
            inStory: this.inStory,
            maxCaptionLength: DEFAULT_MEDIA_CAPTION_MAXLENGTH,
        });
        that.$el.html(videoFlyoverTemplate(viewModel)).sdaInitWidgets();

        that.tagging = new TaggingRightPanelView({el: '#video-tag-panel'});
        that.subViews = [that.tagging];

        that.tagging.resetTags(legacyModel.get('tags'));
        that.$el.open();

        const videoModel = VideoModel.extend({
            url: '/api/story/video/' + that.packageId,
            urlRoot: '/api/story/video/' + that.packageId,
        });

        const clipCollection = VideoCollection.extend({
            url: '/api/story/video/' + that.packageId,
            urlRoot: '/api/story/video/' + that.packageId,
            legacyModel: videoModel,
        });

        clipping.init({
            that,
            model: legacyModel,
            VideoModel: videoModel,
            clipCollection,
            isNewscast: legacyModel.isNewscast,
            mediaSearch: search,
            story: that.inStory,
        });

        clipping.openVideoFlyover(legacyModel, that.userModel.userHasPermissionSet('package.add-media', 'global'));

        that.$('.button-save-media').click(that._saveBtnHandler);

        that.$('#cancel-video-modal-' + uuid).click(that._cancelBtnHandler);

        /**
         * Media Access Rights
         * Allows users to change access rights of an original media only for the properties user has permission for
         */
        const mediaAccessRightsEle = document.getElementById('MediaAccessRightsSection-Video');
        if (mediaAccessRightsEle && getFeatureFlag('media.accessRights')) {
            const isEditable = this.newModel.get('original') === 'true' && mediaAccessRightsEle.hasAttribute('data-is-editable');

            const onSave = brandUuidList => {
                this.newModel.set({brandUuidList});
                this._saveBtnHandler();
            };

            reactRender(
                <MediaAccessRightsSidebarItem
                    selectedBrandUuids={this.newModel.get('brandUuidList') || []}
                    availableBrandUuids={getAvailableBrandUuids()}
                    availableAdminBrandUuids={getAvailableAdminBrandUuids()}
                    isEditable={isEditable}
                    onSave={onSave}
                />,
                mediaAccessRightsEle,
            );
        }
        /**
        * Video metadata enchancement
        * Allows users to change tags for video
        */
        const mediaTagsEl = document.getElementById('MediaTags');
        if (mediaTagsEl) {
            const _videoModel = this.newModel;
            // const isEditable = _videoModel.get('original') === 'true' && mediaTagsEl.hasAttribute('data-is-editable'); // for Q2

            reactRender(
                <MediaTagsSidebarItem
                    tags={_videoModel.get('tags')}
                    isEditable={false} // in this phase it should be read only list. Will be changed in next phase.
                />,
                mediaTagsEl,
            );
        }
    },
    _openClippingPanel(e) {
        const isAwsAsset = this.newModel.get('assetType')?.toUpperCase() === 'HMS_AWS';
        const isFeatureFlagOn = () => getFeatureFlag('clipperUi_video:enabled');
        if (isAwsAsset && isFeatureFlagOn()) {
            try {
                // new clipper ui
                new clipperUiView({el: '#clipper-ui-fly-over'})
                    .render(this.newModel);
                return;
            } catch (err) {
                console.error(err);
            }
        }

        // legacy clipper ui
        clipping._openVideoEditorPanel(e);
    },
    validate() {
        let isValid = true;
        //isValid is on the right side of the logical conjuction operator
        //to run all validators even after one of them indicates error.
        const $videoCaption = $('#media-video-caption');
        const videoCaptionText = $('#media-video-caption').text()
            ?.trim();
        isValid = videoCaptionText?.length > 0 && maxLength($videoCaption) && !(richTextRegex).test($videoCaption.text()) && isValid;
        if (!isValid) {
            $('#media-video-caption').sdaError();
        }
        this.$el.find('.media-panel-field').each((i, el) => {
            isValid = maxLength(el) && isValid;
        });
        // Must reset the index of the regex that uses a global flag:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/test#Using_test()_on_a_regex_with_the_global_flag
        richTextRegex.lastIndex = 0;
        return isValid;
    },
    _updateModel() {
        const that = this;
        const videoCaptionElement = $('#media-video-caption');
        const captionText = videoCaptionElement.html();
        const cleanedCaptionText = stringify(captionText);
        const attributes = {
            tags: that.tagging.getTags(),
            caption: cleanedCaptionText,
        };

        _.toArray(that.$('.media-panel-field').not('#modal-clip-name')).forEach(function (el) {
            attributes[$(el).data('type')] = $(el).val();
        });

        return Promise.resolve(that.newModel.set(attributes));
    },
    _saveModel() {
        const that = this;

        return new Promise(function (resolve, reject) {
            beforeMainLoader();
            that.newModel
                .save()
                .then(function (data) {
                    completeMainLoader();
                    resolve(data);
                    saveVideoChanges(that.newModel.get('uuid'));
                })
                .fail(function (err) {
                    completeMainLoader();
                    reject(err);
                    logError(err);
                });
        });
    },
    countErrorMessage() {
        messageHandler('error', countErrorMessage());
    },
    _saveBtnHandler(e) {
        e?.preventDefault();
        clipping._stopAllPlayers();
        if (this.validate()) {
            this._updateModel()
                .then(this._saveModel)
                .then(() => {
                    completeMainLoader();
                    eventChannels.media.videoEditor.trigger('save.success', this.newModel.toJSON());
                    messageHandler('success', 'Video successfully updated');
                })
                .catch(err => {
                    console.error(err);
                    completeMainLoader();
                    messageHandler('error', 'Video failed to update');
                });
        } else {
            this.countErrorMessage();
        }
        return false;
    },
    _cancelBtnHandler() {
        this.$('.sda-media-editor').player('stop');
        clipping._stopAllPlayers();
        eventChannels.media.videoEditor.trigger('cancel');

        return false;
    },
    _saveClipModel(legacyModel) {
        eventChannels.media.videoEditor.trigger('attach.clip', legacyModel);
    },
    _removeClip(e, legacyModel) {
        const uuid = legacyModel.get('video').uuid;

        eventChannels.media.videoEditor.trigger('remove.clip', uuid);
    },
    _attributeChanged(attributeName) {
        changeVideoAttribute(attributeName, {
            label: this.newModel.get('uuid'),
        });
    },
    _gaLogChangeTitle() {
        this._attributeChanged('title');
    },
    _gaLogChangeCaption() {
        this._attributeChanged('caption');
    },
    _gaLogChangeAltText() {
        this._attributeChanged('alt');
    },
    _gaDownloadVideo() {
        mp4Download(this.newModel.get('uuid'));
    },
    _registerHandlebarHelpers() {
        Handlebars.registerHelper('showStopImage', videoModel => {
            const isFeatureEnabled = this.debugModel.getFeatureFlag('videoEmbedStopImage');
            const isUplynkVideo = !!videoModel.externalId;
            return isFeatureEnabled && isUplynkVideo;
        });
    },
});

export default VideoEditorView;
